import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified, getValueFromLocalStorage } from '../../utilities/utilityFunctions';
import { defaultDoc } from '../share/defaultDoc';
import type { PmCheckList } from './pmCheckList.types';

export const pmCheckListPullQueryBuilder = (document: PmCheckList) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }
  const query = print(gql`
    query mobilePmAssetInspectionChecklistInfo(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime!
    ) {
      mobilePmAssetInspectionChecklistInfo(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
      ) {
        assetCategoryInspectionTypeCheckListId
        parentChecklist
        id
        assetCategoryId
        stepNo
        stepName
        stepDetails
        inspectionTypeId
        inspectionTypeName
        dateModified
        dateCreated
        site
        discipline
        isActive
        children {
          assetCategoryInspectionTypeCheckListId
          parentChecklist
          id
          assetCategoryId
          stepNo
          stepName
          stepDetails
          inspectionTypeId
          inspectionTypeName
          dateModified
          dateCreated
          site
          discipline
          isActive
        }
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
    },
  };
};
